import React from "react";
import { useController } from "react-hook-form";
import ZeroOrGreaterMonetaryAmountInPoundsField from "../zero-or-greater-monetary-amount-in-pounds-field";

type Props = {
  name: string;
} & Partial<
  React.ComponentProps<typeof ZeroOrGreaterMonetaryAmountInPoundsField>
>;

export const RHFZeroOrGreaterMonetaryAmountInPoundsField: FC<Props> = ({
  name,
  ...delegateProps
}) => {
  const {
    field: { value, onChange, onBlur, ref },
  } = useController({ name });

  return (
    <ZeroOrGreaterMonetaryAmountInPoundsField
      valueInPence={value}
      onChangeInPence={onChange}
      onBlur={onBlur}
      name={name}
      inputRef={ref}
      {...delegateProps}
    />
  );
};

export default RHFZeroOrGreaterMonetaryAmountInPoundsField;
